import './Modal.scss'
import iconCloseModal from '../../../assets/iconCloseModal.svg'

const Modal = ({ isOpenModal, closeModal, children, iconModal, titleModal, subTitleModal }) => {
  return (
    <div className={`modal-container  ${isOpenModal && 'open'}`} onClick={closeModal}>
      <div className={`modal`} onClick={(e) => e.stopPropagation()}>
        <div className="close-modal s-cross-center s-main-center" onClick={closeModal}>
          <img src={iconCloseModal} alt="icon close modal" />
        </div>
        <img src={iconModal} className="modal__icon mb-20" alt="icon modal"/>
        <h1 className="poppins-40 modal__title mb-20 ">{titleModal}</h1>
        {subTitleModal && <p className="source-20 modal__subtitle mb-20">{subTitleModal}</p>}

        {children}
      </div>
    </div>
  )
}

export default Modal
